import React  from 'react';
import { observer } from 'mobx-react-lite';
import { Container } from '@pixi/react';

import { freeBetStore } from '../../../store/freeBetStore';

import FreeBet from '../../../components/common/freeBet';

const FreeBetWrapper = observer(() => {
  const { isShowFreeBetPopup } = freeBetStore;

  if (!isShowFreeBetPopup) return null;

  return (
    <Container name='FreeBetWrapperContainer'>
      <FreeBet />
    </Container>
  );
});

export default FreeBetWrapper;
